import 'regenerator-runtime/runtime';
import { call, put, fork, select, takeEvery } from 'redux-saga/effects';
import { parseError } from 'logic/helpers';
import history from 'logic/history';
import api from 'api';
import PATHS from 'constants/paths';
import * as actionCreators from './actionCreators';
import * as actions from './actions';
import { list as listSelector } from './selectors';

function* fetchReviewsRequest(req) {
  try {
    const nextPageUrl = req.payload.nextPage;
    const list = yield select(listSelector);

    if (nextPageUrl || !list.length) {
      const { results, nextPage } = nextPageUrl
        ? yield call(api.fetchNextPage.bind(null, nextPageUrl))
        : yield call(api.fetchReviews.bind(null));
      yield put(actionCreators.fetchReviewsSuccess({ list: results, nextPage }));
    }
  } catch (e) {
    yield put(actionCreators.fetchReviewsFailure(parseError(e)));
  }
}

function* fethPublicCottageRequest(req) {
  try {
    const { cottageId } = req.payload;
    const cottage = yield call(api.fetchPublicCottage.bind(null, cottageId));

    yield put(actionCreators.fetchPublicCottageSuccess({ cottage }));
  } catch (e) {
    yield put(actionCreators.fetchPublicCottageFailure(parseError(e)));
  }
}

function* postReviewRequest(req) {
  try {
    const { data } = req.payload;
    const review = yield call(api.postReview.bind(null, data));

    setTimeout(() => history.push(PATHS.reviews.root), 500);

    yield put(actionCreators.postReviewSuccess({ review }));
  } catch (e) {
    yield put(actionCreators.postReviewFailure(parseError(e)));
  }
}

function* postReviewReplyRequest(req) {
  try {
    const { reviewId, data } = req.payload;
    const { id, reply } = yield call(api.postReviewReply.bind(null, reviewId, data));

    yield put(actionCreators.postReviewReplySuccess({ id, reply }));
  } catch (e) {
    yield put(actionCreators.postReviewReplyFailure(parseError(e)));
  }
}

function* deleteReview(req) {
  try {
    const { id } = req.payload;
    yield call(api.deleteReview.bind(null, id));

    yield put(actionCreators.resetList());
    yield put(actionCreators.fetchReviewsRequest({}));
    yield put(actionCreators.deleteReviewReplySuccess());
  } catch (e) {
    yield put(actionCreators.deleteReviewFailure(parseError(e)));
  }
}

function* deleteReviewReply(req) {
  try {
    const { id } = req.payload;
    yield call(api.deleteReviewReply.bind(null, id));

    yield put(actionCreators.resetList());
    yield put(actionCreators.fetchReviewsRequest({}));
    yield put(actionCreators.deleteReviewReplySuccess());
  } catch (e) {
    yield put(actionCreators.deleteReviewFailure(parseError(e)));
  }
}

export default [
  fork(takeEvery, actions.FETCH_REVIEWS_REQUEST, fetchReviewsRequest),
  fork(takeEvery, actions.FETCH_PUBLIC_COTTAGE_REQUEST, fethPublicCottageRequest),
  fork(takeEvery, actions.POST_REVIEW_REQUEST, postReviewRequest),
  fork(takeEvery, actions.POST_REVIEW_REPLY_REQUEST, postReviewReplyRequest),
  fork(takeEvery, actions.DELETE_REVIEW_REQUEST, deleteReview),
  fork(takeEvery, actions.DELETE_REVIEW_REPLY_REQUEST, deleteReviewReply),
];
